export const sidebar = {
  dashboardLink: 'Pagina de pornire',
  sectionContracts: 'Contracte',
  contractsLink: 'Contracte',
  grupareContracteLink: 'Acorduri-cadru',
  sectionAuctions: 'Proceduri de achiziție',
  licitatieAchizitieLink: 'Proceduri de achiziție',
  sectionCatalogs: 'Cataloage',
  partnersLink: 'Parteneri',
  sectionAdministration: 'Administrare',
  accesSecuritateLink: 'Acces și securitate',
  usersLink: 'Utilizatori',
  configurareAplicatieLink: 'Configurare aplicație',
  mappingAdRolesLink: 'Corespondențe roluri AD'
}
